(function () {
  var sections = document.querySelectorAll('.cta-strip');
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = prefersReduced ? null : new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  sections.forEach(function (section) {
    section.querySelectorAll('.reveal').forEach(function (el) {
      if (prefersReduced) {
        el.classList.add('is-visible');
      } else {
        observer.observe(el);
      }
    });
  });
})();
